<!-- TOP MARQUEE -->
<section class="overflow-hidden position-relative half-section overlap-height pb-0"
         style="padding-top:0; padding-bottom:0; margin-bottom:-10px;">

  <div class="container-fluid overlap-gap-section" style="padding:0;">
    <div class="row position-relative" style="margin:0;">
      
      <div class="col swiper swiper-width-auto text-center pb-0 sm-pb-0px"
           data-slider-options='{ 
             "slidesPerView": "auto", 
             "spaceBetween": 50, 
             "speed": 8000, 
             "loop": true, 
             "autoplay": { "delay":0, "disableOnInteraction": false }, 
             "allowTouchMove": false, 
             "effect": "slide" 
           }'
           style="padding:0; margin:0;">
        
        <div class="swiper-wrapper marquee-slide">
          <div class="swiper-slide" *ngFor="let item of marqueeItems">
            <div class="fs-180 xl-fs-120 sm-fs-80 text-extra-medium-gray fw-600 ls-minus-8px sm-ls-minus-4px word-break-normal">
              {{item}}
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</section>



<!-- BOTTOM MARQUEE -->
<section class="position-relative pb-0 marquee-tight" 
         style="padding-top:0; padding-bottom:0; margin-top:-1px;">

  <!-- LOWER BACKGROUND (BOTTOM HALF ONLY) -->
  <div class="bg-base-color bg-sliding-line"
       style="position:absolute; bottom:0; left:0; width:100%; height:50%; pointer-events:none;"></div>

  <div class="container-fluid" style="padding:0; position: relative;">
    <div class="row position-relative" style="margin:0;">

      <div class="col swiper swiper-width-auto text-center pb-0"
           data-slider-options='{ 
             "slidesPerView":"auto",
             "spaceBetween": 50,
             "speed":8000,
             "loop":true,
             "autoplay":{"delay":0,"disableOnInteraction":false,"reverseDirection":true},
             "allowTouchMove":false,
             "effect":"slide"
           }'
           style="padding:0; margin:0;">

        <div class="swiper-wrapper marquee-slide">
          <div class="swiper-slide" *ngFor="let item of marqueeItems">
            <div class="fs-150 xl-fs-120 sm-fs-80 text-black fw-600 ls-minus-5px sm-ls-minus-4px"
                 style="margin-top:-5px;">
              {{ item }}
            </div>
          </div>
        </div>

      </div>

    </div>
  </div>

</section>
